// utils/offlineStorage/queries.ts - utils/offlineStorage/core.ts class split (methods: queries)

import { OfflineStorage } from './class.js';

declare module './class.js' {
  interface OfflineStorage {
  remove(key: string): void;
  clearAll(): void;
  getCacheAge(key: string): number | null;
  isValid(key: string): boolean;
  }
}

export function applyQueriesMethods() {
  Object.assign(OfflineStorage.prototype, {
    /**
   * Remove item from cache
   */
  remove(key: string): void {
    localStorage.removeItem(this.prefix + key);
  },
    /**
   * Clear all cache items
   */
  clearAll(): void {
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.startsWith(this.prefix)) {
        localStorage.removeItem(key);
      }
    });
  },
    /**
   * Get cache age in minutes
   */
  getCacheAge(key: string): number | null {
    try {
      const item = localStorage.getItem(this.prefix + key);
      if (!item) return null;

      const cacheItem = JSON.parse(item);
      return Math.floor((Date.now() - cacheItem.timestamp) / 1000 / 60);
    } catch {
      return null;
    }
  },
    /**
   * Check if cache is still valid
   */
  isValid(key: string): boolean {
    try {
      const item = localStorage.getItem(this.prefix + key);
      if (!item) return false;

      const cacheItem = JSON.parse(item);
      return Date.now() - cacheItem.timestamp < cacheItem.expiresIn;
    } catch {
      return false;
    }
  },
  });
}
